module.exports = __webpack_public_path__ + "img/phone.d357be03.svg";